import { alpha } from '@mui/material';
import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import {
  Box,
  Button,
  Card,
  Icons,
  Link,
  Stack,
  styled,
  Text,
} from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

const BlockNumberCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.secondary.main}`,
  backgroundColor: alpha(theme.palette.error.main, 0.05),
  marginTop: theme.spacing(2.5),
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'left',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const GetTheAppCTA = ({ platformLink }: { platformLink?: string }) => {
  const { trackEventGA4 } = useAppConfigContext();
  return (
    <Text variant="body1">
      Don&apos;t have the app?{'  '}
      <Link
        href={platformLink}
        variant="body1"
        onClick={() => {
          trackEventGA4({
            event_name: 'report_element_engagement',
            report_type: 'phone',
            type: 'get_app',
            interacted_from: 'overview',
          });
        }}
      >
        Get it now
      </Link>
    </Text>
  );
};

export const BlockNumberSection = () => {
  const { userAgent } = navigator;
  const isAppleDevice = /iPad|iPhone|iPod|Macintosh/.test(userAgent);
  const { trackEventGA4 } = useAppConfigContext();
  const {
    links: { brandIosUrl, brandAndroidUrl },
  } = useAppConstantsContext();

  const platformLink = isAppleDevice ? brandIosUrl : brandAndroidUrl;

  const { isMobile, isDesktop } = useScreenSize();

  return (
    <BlockNumberCard variant="outlined">
      <Stack
        direction="row"
        spacing={{ xs: 1, sm: 4 }}
        justifyContent="left"
        width="100%"
        alignItems="center"
      >
        <Icons.Block
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: 50,
          })}
        />
        <Box>
          <Text variant="body1" fontSize={18} fontWeight={700}>
            Block this number in the app!
          </Text>
          {!isMobile && <GetTheAppCTA platformLink={platformLink} />}
        </Box>
      </Stack>

      {!isDesktop && (
        <Button
          variant="contained"
          color="success"
          sx={(theme) => ({
            width: { xs: '100%', sm: '30%' },
            maxWidth: { sm: theme.spacing(27) },
            height: theme.spacing(5),
            padding: theme.spacing(1),
          })}
          onClick={() => {
            window.open(platformLink, '_blank');
            trackEventGA4({
              event_name: 'report_element_engagement',
              report_type: 'phone',
              type: 'block_number',
              interacted_from: 'overview',
            });
          }}
        >
          <Text>Block now</Text>
        </Button>
      )}
      {isMobile && <GetTheAppCTA platformLink={platformLink} />}
    </BlockNumberCard>
  );
};
